import { type FC } from 'react';
import { AnimatePresence } from 'framer-motion';

import { LotteryContainer } from '@/components/Lottery/LotteryContainer/LotteryContainer';
import { LotteryInProgress } from '@/components/Lottery/LotteryInProgress/LotteryInProgress';
import { useAppSelector } from '@/redux/store';

const LotteryMain: FC = () => {
  const currentTierInDraw = useAppSelector(
    (state) => state.lottery.currentTier.inDraw,
  );

  if (currentTierInDraw === undefined) {
    return null;
  }

  return (
    <AnimatePresence>
      {currentTierInDraw ? <LotteryInProgress /> : <LotteryContainer />}
    </AnimatePresence>
  );
};

export { LotteryMain };
